<template>
    <div :class="$style.wrapper">
        <PopoverForm
            :title="title"
            :name='name'
            :phone='phone'
            :positionId='position_id'
            :password='password'
        >
            <slot></slot>
            <div slot="content">
                <el-form :rules="rules" label-width="80px" size="small">
                    <el-form-item label="姓名：">
                        <el-input v-model='name'></el-input>
                    </el-form-item>
                    <el-form-item label="手机号：">
                        <el-input v-model='phone'></el-input>
                    </el-form-item>
                    <el-form-item label="权限：">
                        <el-select v-model="position_id" placeholder="请选择">
                            <el-option
                              v-for="item in options"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="密码：">
                        <el-input v-model='password' type='password'></el-input>
                    </el-form-item>
                </el-form>
            </div>
        </PopoverForm>
    </div>
</template>

<script>
    import Vue from 'vue';
    import PopoverForm from '../Common/PopoverForm.vue';
    import { session_id } from '../../stores/api';

    Vue.component('PopoverForm', PopoverForm);
    // const session_id = window.location.host.indexOf('localhost') >= 0 ? 'ed668297355b199e597973c0cd768c22' : window.localStorage.getItem('session_id');
    export default {
        props: ['title'],

        data () {
            return {
                name: '',
                phone:'',
                password:'',

                options: [{
                  value: '选项1',
                  label: '员工'
                }, {
                  value: '选项2',
                  label: '经销商'
                }],
                position_id: ''
            };
        },
        methods:{
            //获取职位列表
            getzw(){
                this.$http.get(this.$reqUrl+'user.php?act=get_staff_position_list&content='+1+'&session_id='+session_id)
                .then(res=>{
                    this.options=res.data.position_nav;
                    for(let i=0;i<res.data.position_nav.length;i++){
                      this.options = res.data.position_nav.map(item => {
                       return {value: item.position_id, label: item.position_name};
                    });
                    }
                })
            }
        },
        mounted(){
            this.getzw()
        }
    };
</script>

<style lang="less" module>
    .wrapper {
        display: inline-block;
    }
</style>
<style>
.el-input--suffix .el-input__inner {
    padding-right: 80px;
}
</style>



// WEBPACK FOOTER //
// src/components/Management/StaffForm.vue